module.exports = __webpack_public_path__ + "static/media/dot_black.67a827e2.svg";